import React from "react";

const defaultRows = [
  { label: "Directors", current: "", previous: "" },
  { label: "KMPs", current: "", previous: "" },
  { label: "Workers", current: "", previous: "" },
  { label: "Employees", current: "", previous: "" },
];

const EmployeeCountComparisonTable = ({ data, setData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...data];
    updated[index][field] = value;
    setData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}></th>
            <th style={tableHeaderStyle}>Current Financial Year</th>
            <th style={tableHeaderStyle}>Previous Financial Year</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                {row.label}
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  placeholder={`Total Number of ${row.label}`}
                  value={row.current}
                  onChange={(e) =>
                    handleChange(index, "current", e.target.value)
                  }
                  style={inputFieldStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  placeholder={`Total Number of ${row.label}`}
                  value={row.previous}
                  onChange={(e) =>
                    handleChange(index, "previous", e.target.value)
                  }
                  style={inputFieldStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "85%", // Increased width
  padding: "10px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  textAlign: "center",
  outline: "none",
};

export default EmployeeCountComparisonTable;
